var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"257145cec0b5b683c25fe593e5aead3d74078374"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yunnanzhiye-pc-web"]={id:"257145cec0b5b683c25fe593e5aead3d74078374"};
      